import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Home from './Components/Home';
import Inicial from './Components/Inicial';
import InicialCat from './Components/InicialCat';
import Login from './Components/Login/Login';
import { UserStorage } from './UserContext';
import User from './Components/User/User';
import ProtectedRoute from './Components/Helper/ProtectedRoute';
import Photo from './Components/Photo/Photo';
import Date from './Components/Date/Date';
import UserProfile from './Components/User/UserProfile';
import NotFound from './Components/NotFound';




function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <UserStorage>
          <Header />
          <main id="main" className="AppBody">
            <Routes>
              <Route path="/" element={<InicialCat />} />
              <Route path="login/*" element={<Login />} />
              <Route
                path="conta/*"
                element={
                  <ProtectedRoute>
                    <User />
                  </ProtectedRoute>
                }
              />
              <Route path="datas/" element={<Date />} />
              <Route path="foto/:id" element={<Photo />} />
              <Route path="perfil/:user" element={<UserProfile />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
       
          </main>

          <Footer />
        </UserStorage>
      </BrowserRouter>

    </div>
  );
}

export default App;
